import(/* webpackMode: "eager", webpackExports: ["V2CareerScreen"] */ "/app/apps/platform-web/components/v2/screens/V2CareerScreen.tsx");
